import { DEFAULT_ERROR_MESSAGE } from './constants';
import { getUserLanguage, config, useTranslation } from '@shopee-user/platform';

// Types
import { TranslationFunction } from '@shopee-user/i18n/src/types';

const EMPTY_OBJECT = {};

const isNonLive = config.ENV !== 'live' && config.ENV !== 'liveish';

function getErrorMessage({
  error,
  error_msg,
  errorMap = EMPTY_OBJECT,
  params = EMPTY_OBJECT,
  t,
}: {
  error?: string | number | null;
  error_msg?: string | null;
  errorMap?: Record<string | number, string>;
  params?: { [key: string]: string };
  t: TranslationFunction;
}): string {
  // return empty string when there is no error
  if (!error) {
    return '';
  }

  let finalErrorMessage = '';
  let isDefaultErrorMessage = false;

  // try with provided custom errorMap, and errorMap['default']
  // if none of them work, return DEFAULT_ERROR_MESSAGE based on language field in cookie
  if (errorMap[error]) {
    finalErrorMessage = t(errorMap[error], {
      ...params,
      context: config.BUSINESS_TARGET,
    });
  } else {
    finalErrorMessage = errorMap['default']
      ? t(errorMap['default'], {
          ...params,
          context: config.BUSINESS_TARGET,
        })
      : DEFAULT_ERROR_MESSAGE[getUserLanguage()];
    isDefaultErrorMessage = true;
  }

  if (isNonLive) {
    return `${finalErrorMessage} [DEBUG: ${error} ${error_msg || ''}]`;
  } else {
    // we add the error code to error message when showing default error message
    // this will make the live user to report easier
    // https://jira.shopee.io/browse/SPUS-3592
    return isDefaultErrorMessage
      ? `${finalErrorMessage} [${error}]`
      : finalErrorMessage;
  }
}

export const useGetErrorMessage = () => {
  const { t } = useTranslation();

  return {
    getErrorMessage: (args: {
      error?: string | number | null;
      error_msg?: string | null;
      errorMap?: Record<string | number, string>;
      params?: { [key: string]: string };
    }) => getErrorMessage({ ...args, t }),
  };
};
